<!-- Can re-use this template to render unexpected error details -->
<ng-template #unexpectedErrorMsgTemplate>
  <dxo-alert *ngIf="unexpectedErrorMsg">
    <div [innerHTML]="unexpectedErrorMsg"></div>
  </dxo-alert>
</ng-template>

<!-- Can re-use this template to render a list of people -->
<ng-template #searchResultTemplate let-person="person">
  <div class="person-result">
    <div class="person-list-item">
      <div class="bold text" data-e2e="person-fullname-label">
        {{ person.lastName }}, {{ person.firstName }}
      </div>
      <div class="person-list-item-details">
        <div class="item">
          <div class="bold text">SSN</div>
          <div data-e2e="person-searchterm">{{ searchTerm }}</div>
        </div>
        <div class="item"><!-- intentionally empty for now, for spacing --></div>
      </div>
    </div>
  </div>
</ng-template>

<!--
Main page content, w/ different states
-->
<div class="parent" [formGroup]="form">
  <div class="row" [ngSwitch]="state">

    <!-- Initial state: prompt user to enter an ssn to search -->
    <ng-template [ngSwitchCase]="STATES.INITIAL">
      <dxo-card-responsive bodyHeader="Enter employee Social Security number (SSN)"
                           data-e2e="search-by-ssn-header">
        <card-body>
          <ng-container *ngTemplateOutlet="unexpectedErrorMsgTemplate" />
          Before we get started, let's check to see if this employee already exists in the system.

          <dxo-text-input formControlName="searchTerm"
                          label="Social Security number"
                          (input)="formatSearchTerm($event)"
                          [fullWidth]="true"
                          (onKeypress)="onSearchKeypress($event)"
                          dataE2eInput="search" />
        </card-body>
        <card-footer class="footer">
          <dxo-button-v2 size="small"
                         [disabled]="!form.valid"
                         icon="search"
                         data-e2e="search-by-ssn-search-button"
                         (click)="onSearchClick()">Check employee SSN
          </dxo-button-v2>
        </card-footer>
      </dxo-card-responsive>
    </ng-template>

    <!-- User's search yielded 0 results -->
    <ng-template [ngSwitchCase]="STATES.NO_RESULTS">
      <dxo-card-responsive bodyHeader="Confirm SSN to proceed"
                           data-e2e="search-by-ssn-header">
        <card-body>
          <ng-container *ngTemplateOutlet="unexpectedErrorMsgTemplate" />
          <dxo-alert status="success"
                     text="There are no existing employee profiles with this SSN in the system."
                     data-e2e="search-by-ssn-notice" />
          Confirm the SSN below is correct and proceed to create this employee profile.
          <div class="no-response-verify">
            <p class="bold text">SSN</p>
            <p>{{ form.get('searchTerm')?.value }}</p>
          </div>
        </card-body>
        <card-footer class="footer">
          <div class="button-container">
            <dxo-button-v2 variant="secondary"
                           size="small"
                           data-e2e="search-by-ssn-cancel-button"
                           (click)="onCancelClick()">Cancel
            </dxo-button-v2>
            <dxo-button-v2 size="small"
                           data-e2e="search-by-ssn-add-button"
                           (click)="onAddEmployeeClick()">Add Employee
            </dxo-button-v2>
          </div>
        </card-footer>
      </dxo-card-responsive>
    </ng-template>

    <!-- User's search yielded 1 or more results in the current user's group -->
    <ng-template [ngSwitchCase]="STATES.RESULTS_IN_USERS_GROUP">
      <dxo-card-responsive bodyHeader="This SSN matches an employee in your group"
                           data-e2e="search-by-ssn-header">
        <card-body>
          <ng-container *ngTemplateOutlet="unexpectedErrorMsgTemplate" />
          View this employee's detail page to edit important details, such as employment status and dependent
          information.
          <ng-container *ngTemplateOutlet="searchResultTemplate; context: { person: searchResult }" />
        </card-body>
        <card-footer class="footer">
          <div class="button-container">
            <dxo-button-v2 variant="secondary"
                           size="small"
                           data-e2e="search-by-ssn-cancel-button"
                           (click)="onCancelClick()">Cancel
            </dxo-button-v2>
            <dxo-button-v2 size="small"
                           data-e2e="search-by-ssn-view-button"
                           [routerLink]="getPersonUrl(searchResult)"
                           [queryParams]="{token}"
                           label="View employee details" />
          </div>
        </card-footer>
      </dxo-card-responsive>
    </ng-template>

    <!-- User's search yielded 1 or more results NOT in the current user's group -->
    <ng-template [ngSwitchCase]="STATES.RESULTS_NOT_IN_USERS_GROUP">
      <dxo-card-responsive bodyHeader="This SSN matches a profile in the system"
                           data-e2e="search-by-ssn-header">
        <card-body>
          <ng-container *ngTemplateOutlet="unexpectedErrorMsgTemplate" />
          <dxo-alert
            text="We found an employee profile with this SSN in our system, however they are not in your group."
            data-e2e="search-by-ssn-notice" />
          Confirm the identity below is correct and proceed to add this employee profile to your group.
          <ng-container *ngTemplateOutlet="searchResultTemplate; context: { person: searchResult }" />
        </card-body>
        <card-footer class="footer">
          <div class="button-container">
            <dxo-button-v2 variant="secondary"
                           size="small"
                           data-e2e="search-by-ssn-cancel-button"
                           (click)="onCancelClick()">Cancel
            </dxo-button-v2>
            <dxo-button-v2 size="small"
                           data-e2e="search-by-ssn-add-button"
                           (click)="onAddEmployeeClick()">Add Employee
            </dxo-button-v2>
          </div>
        </card-footer>
      </dxo-card-responsive>
    </ng-template>
  </div>
</div>